import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import UploadQuestionBanksModal from "../question-banks/UploadQuestionBanksModal";

const QuestionExcelUpload = ({
  dropDownQuestionBank,
  onUploadSuccess,
  showToast,
  selectedQuestionBankId = null,
}) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  // If selectedQuestionBankId is provided, filter to show only that question bank
  const filteredQuestionBanks = selectedQuestionBankId
    ? dropDownQuestionBank?.companyDropDown?.filter(
        (qb) => qb._id === selectedQuestionBankId
      )
    : dropDownQuestionBank?.companyDropDown || [];

  const handleUploadSuccess = () => {
    setShowUploadModal(false);
    if (onUploadSuccess) {
      onUploadSuccess();
    }
  };

  return (
    <>
      <Button
        onClick={() => setShowUploadModal(true)}
        className="bg-green-600 hover:bg-green-700"
      >
        <Upload className="mr-2 h-4 w-4" />
        Upload Excel
      </Button>

      <UploadQuestionBanksModal
        open={showUploadModal}
        onOpenChange={setShowUploadModal}
        dropDownQuestionBank={filteredQuestionBanks}
        onUploadSuccess={handleUploadSuccess}
        showToast={showToast}
        preSelectedQuestionBank={selectedQuestionBankId}
      />
    </>
  );
};

export default QuestionExcelUpload;
